<template>
  <b-navbar toggleable="lg" type="dark" variant="primary">
    <b-link :href="home.href">
      <img class="mx-2" src="@/assets/logo.png" alt="Logo">
      <b-navbar-brand>{{ home.title }}</b-navbar-brand>
    </b-link>
    <b-navbar-nav class="ml-auto">
      <b-button variant="light" :href="phonetics.href">
        <i class="fa-solid fa-arrow-up-right-from-square" style="color: #007bff"></i>
        <strong>{{ phonetics.title }}</strong>
        <b-icon variant="primary" icon="box-arrow-right" aria-hidden="true"></b-icon>
      </b-button>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  name: "AuthNav",
  data() {
    return {
      /** 起始页面 */
      home: {
        href: process.env.VUE_APP_PHONETICS_HOME_URL || 'https://johnslanguages.com',
        title: process.env.VUE_APP_TITLE
      },
      phonetics: {
        href: process.env.VUE_APP_PHONETICS_LANGUAGES_URL,
        title: process.env.VUE_APP_PHONETICS_LANGUAGES_TITLE
      }
    }
  }
}
</script>

<style scoped>

</style>
